import { TestCards } from './TestCards';

export class TestingGateway {
    public card: TestCards;

    public constructor() {
        this.card = new TestCards();
    }
}
